module.exports = __webpack_public_path__ + "img/042-perfect.5795a86e.svg";